<template>
  <div>
    <p v-if="message !== null">
      {{ message }}
    </p>

    <player-contests-table
      v-if="isContestsVisible"
      :playerId="playerId"
      :contests="contests"
    />

    <loading-indicator v-if="isLoading" />
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

/**
 * @typedef { import('../model/contest.js').ContestPreview } ContestPreview
 */

import LoadingIndicator   from './LoadingIndicator.vue';
import PlayerContestsTable from './PlayerContestsTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerContests',

  components: {
    LoadingIndicator,
    PlayerContestsTable,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {ContestPreview[] | null} */
      contests: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      if(this.contests !== null && this.contests.length === 0) {
        return 'Нет конкурсов.';
      }

      return null;
    },

    /** @returns {boolean} */
    isContestsVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const contests = this.contests;
      if(contests === null) {
        return false;
      }

      return contests.length > 0;
    },
  },

  created() {
    this.loadContests();
  },

  methods: {
    loadContests() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = '/player/' + this.playerId + '/contests';

      HTTP.get(url)
      .then(response => {
        /** @type {ContestPreview[] | null} */
        const data = response.data.data;
        
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const contests = data;
        //const contests = getContestsForTest();
        contests.sort((a, b) => b.stime - a.stime);

        this.contests = contests;

        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}

/*
function getContestsForTest() {
  return [
    {
      "id": 2969,
      "type": 4,
      "status": 4,
      "ftime": 1733378400,
      "frtime": 1733378505,
      "stime": 1733119200,
      "srtime": 1733119238,
      "playerGroupId": 0
    },
    {
      "id": 3230,
      "type": 5,
      "status": 2,
      "ftime": 1733724000,
      "frtime": 1733724012,
      "stime": 1733378400,
      "srtime": 1733378505,
      "playerGroupId": 0
    },
    {
      "id": 3491,
      "type": 3,
      "status": 1,
      "ftime": 1733983200,
      "frtime": 0,
      "stime": 1733724000,
      "srtime": 1733724012,
      "playerGroupId": 0
    },
  ];
}
*/
</script>
